import { Image, Flex, keyframes} from "@chakra-ui/react";
import shortLogo from '../../../../global/styles/images/launchdeck-short-logo-icon.png'

const ThinkingLogo = ({boxSize}) => {

	const blinkAnimation = keyframes`
  0%, 100% { opacity: 0; }
  50% { opacity: 1; }
`;

	return (
		<Flex w='100%' alignItems='center' justify='center' height='30vh' animation={`${blinkAnimation} 3s ease-in-out infinite`}>
			<Image src={shortLogo} alt="Launchdeck thinking Logo"  maxWidth={boxSize ? boxSize : '5em'} />
		</Flex>
	);
};

export default ThinkingLogo;
